import _generalForwardSolid from "@zenlayer/zen-design-icons/assets/general/ForwardSolid.svg";
import _generalPlaySolid from "@zenlayer/zen-design-icons/assets/general/PlaySolid.svg";
import _generalPauseSplid from "@zenlayer/zen-design-icons/assets/general/PauseSplid.svg";
import _generalRewindSolid from "@zenlayer/zen-design-icons/assets/general/RewindSolid.svg";
import { useControllableValue, useInterval } from 'ahooks';
import { useState } from 'react';
import dayjs, { time2utc } from '../_util/day';
import { pickDomAttrs } from '../_util/utils';
import Button from '../button';
import Icon from '../icon';
import Space from '../space';
import { CUSTOMKEY } from './interface';
import PresetDatePicker from './presetDatePicker';
import { compareTimes, defaultPlayerInterval, defaultPresets, getDefaultValue, getTheFullDate } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PresetDatePickerWidthController = props => {
  const {
    value,
    onChange: _onChange,
    playerControl,
    playerInterval = defaultPlayerInterval,
    ...presetDatePickerProps
  } = props;
  const {
    size = 'm',
    presets = defaultPresets,
    earliestTime,
    latestTime,
    fullMinute
  } = presetDatePickerProps;
  const attrs = pickDomAttrs(presetDatePickerProps);
  const [timeZone, onTimeZoneChange] = useControllableValue(props, {
    defaultValue: dayjs.tz.guess(),
    defaultValuePropName: 'defaultTimeZone',
    valuePropName: 'timeZone',
    trigger: 'onTimeZoneChange'
  });
  const [nowPlaying, setNowPlaying] = useState(!!value);
  const onChange = newValue => {
    if (!newValue) {
      setNowPlaying(false);
    } else if (newValue.datePreset === CUSTOMKEY) {
      setNowPlaying(false);
    } else {
      setNowPlaying(true);
    }
    _onChange === null || _onChange === void 0 || _onChange(newValue);
  };
  useInterval(() => {
    const newValue = getDefaultValue(value, {
      timeZone,
      latestTime,
      earliestTime,
      fullMinute
    });
    _onChange === null || _onChange === void 0 || _onChange(newValue);
  }, nowPlaying ? playerInterval : undefined);
  function onRewindSolid() {
    setNowPlaying(false);
    const span = dayjs(value === null || value === void 0 ? void 0 : value.endTime).valueOf() - dayjs(value === null || value === void 0 ? void 0 : value.startTime).valueOf();
    let startTime = time2utc(dayjs(value === null || value === void 0 ? void 0 : value.startTime).subtract(span, 'milliseconds'));
    if (earliestTime) {
      startTime = compareTimes(startTime, getTheFullDate(earliestTime, {
        forward: false,
        fullMinute
      }))[1];
    }
    const endTime = time2utc(dayjs(startTime).add(span, 'milliseconds'));
    const newValue = {
      datePreset: CUSTOMKEY,
      startTime,
      endTime
    };
    _onChange === null || _onChange === void 0 || _onChange(newValue);
  }
  function onForwardSolid() {
    setNowPlaying(false);
    const span = dayjs(value === null || value === void 0 ? void 0 : value.endTime).valueOf() - dayjs(value === null || value === void 0 ? void 0 : value.startTime).valueOf();
    let endTime = time2utc(dayjs(value === null || value === void 0 ? void 0 : value.endTime).add(span, 'milliseconds'));
    if (latestTime) {
      endTime = compareTimes(endTime, getTheFullDate(latestTime, {
        fullMinute
      }))[0];
    }
    const startTime = time2utc(dayjs(endTime).subtract(span, 'milliseconds'));
    const newValue = {
      datePreset: CUSTOMKEY,
      startTime,
      endTime
    };
    _onChange === null || _onChange === void 0 || _onChange(newValue);
  }
  function onPauseSplid() {
    setNowPlaying(false);
    const newValue = getDefaultValue({
      ...value,
      datePreset: CUSTOMKEY
    }, {
      timeZone,
      latestTime,
      earliestTime,
      fullMinute
    });
    _onChange === null || _onChange === void 0 || _onChange(newValue);
  }
  function onPlaySolid() {
    setNowPlaying(true);
    const newValue = getDefaultValue({
      datePreset: presets[0]
    }, {
      timeZone,
      latestTime,
      earliestTime,
      fullMinute
    });
    _onChange === null || _onChange === void 0 || _onChange(newValue);
  }
  const baseButtonProps = {
    type: 'normal',
    textBaseColor: true,
    size,
    disabled: !value
  };
  return /*#__PURE__*/_jsxs(Space, {
    ...attrs.data,
    children: [/*#__PURE__*/_jsx(PresetDatePicker, {
      ...presetDatePickerProps,
      value: value,
      onChange: onChange,
      timeZone: timeZone,
      onTimeZoneChange: onTimeZoneChange
    }), /*#__PURE__*/_jsxs(Button.Group, {
      children: [/*#__PURE__*/_jsx(Button, {
        ...baseButtonProps,
        icon: /*#__PURE__*/_jsx(Icon, {
          type: "general/RewindSolid"
        }),
        disabled: baseButtonProps.disabled || earliestTime === (value === null || value === void 0 ? void 0 : value.startTime),
        onClick: onRewindSolid
      }), nowPlaying ? /*#__PURE__*/_jsx(Button, {
        ...baseButtonProps,
        icon: /*#__PURE__*/_jsx(Icon, {
          type: "general/PauseSplid"
        }),
        onClick: onPauseSplid
      }) : /*#__PURE__*/_jsx(Button, {
        ...baseButtonProps,
        icon: /*#__PURE__*/_jsx(Icon, {
          type: "general/PlaySolid"
        }),
        onClick: onPlaySolid
      }), /*#__PURE__*/_jsx(Button, {
        ...baseButtonProps,
        icon: /*#__PURE__*/_jsx(Icon, {
          type: "general/ForwardSolid"
        }),
        disabled: baseButtonProps.disabled || (value === null || value === void 0 ? void 0 : value.datePreset) !== CUSTOMKEY || latestTime === (value === null || value === void 0 ? void 0 : value.endTime),
        onClick: onForwardSolid
      })]
    })]
  });
};
export default PresetDatePickerWidthController;